import { useEffect, useState } from "react";
import PlanCard from "./planCard";
import PaymentPage from "./PaymentPage";
import ZeroPaymentCard from "./ZeroPaymentCard";
import CredentialService from '../../Services/credential.services';
import TokenService from "../../Services/token.service";
import PaymentService from '../../Services/payment.services';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { sidebarStore } from "../store/SidebarStore";
import { getActingAs } from "../../helpers/actingAs";

export default function PriceOptions() {
    const [dataLoaded, setDataLoaded]=useState(false);
    const [totalPrice, setTotalPrice]=useState(0.0);
    const [unitPrice, setUnitPrice]=useState(0.0);
    const [companies, setCompanies]=useState<string[]>([]);
    const [userEmail, setUserEmail]=useState("");
    const [userId, setUserId]=useState("");
    const [canPay, setCanPay] = useState(false);
    const [, setCompanyCount] = useState(0)
    const [widgetReady, setWidgetReady] = useState(false);
    const [isMarkingPaid, setIsMarkingPaid] = useState(false);
    const navigate = useNavigate();

    useEffect(()=>{
        GetPricingOptions();
        setUserEmail(TokenService.getUser().user.email);
        setUserId(TokenService.getUser().user.id);
    },[]); 



const GetPricingOptions = async()=>{
    setDataLoaded(false);
    var response= await CredentialService.GetPricing()
    if(response.success){
        setTotalPrice(response.data.totalCost);
        setUnitPrice(response.data.unitCost);
        setCompanies(response.data.insuranceCompanies);
        setCanPay(response.data.canPay);
        setDataLoaded(true);
        setCompanyCount(response.data.companyCount);
        
    }   
}

// Nothing to charge for: skip the IntelliPay widget entirely and show the
// zero-total summary instead.  canPay is still required so that a user who has
// not finished their questionnaire (or has no insurance requests, which also
// prices out at zero) keeps seeing the existing disabled plan card.
const isZeroPayment = canPay && totalPrice === 0;

// An admin acting as the dentist collects payment outside the app and only records it here
const isActingAs = !!getActingAs();

const markAsPaid = async () => {
    setIsMarkingPaid(true);
    // Same payload PaymentPage posts after an IntelliPay approval, minus the IntelliPay ids
    const postPaymentPayload = {
        isAnnualPayment: true,
        totalAnnualPrice: totalPrice,
        pricePerMonth: totalPrice,
        shouldCreateFirstPayment: true,
        isFirstPaymentPaid: true,
        IntelliPayTransactionId: "",
        IntelliPayCustId: "",
    };
    const result = await PaymentService.PostPayment(postPaymentPayload);
    if (!result) {
        // PostPayment swallows the error, so a missing result is the only sign it failed
        toast.error("Could not mark this request as paid. Please try again.", { position: "top-center" });
        setIsMarkingPaid(false);
        return;
    }
    sidebarStore.setCanCreateNewRequest(true);
    const url = await CredentialService.GetNextPage();
    navigate("/" + url, { replace: true });
}

  return (
    <div>

        {dataLoaded?
            isZeroPayment?
            <div className="">
                <div className="">
                    <h1 className="font-medium leading-tight text-4xl mt-0 mb-12 text-black-600 text-center">
                    You are just one step away!
                    </h1>
                    <div className="flex items-center justify-center min-h-screen bg-gray-100 grid-cols-2 gap-4">
                        <ZeroPaymentCard insuranceCompanies={companies} />
                    </div>
                </div>
            </div>
            :
            <div className="">
                <div className="">
                    <h1 className="font-medium leading-tight text-4xl mt-0 mb-12 text-black-600 text-center">
                    You are just one step away!
                    </h1>
                    <div className="flex items-center justify-center min-h-screen bg-gray-100 grid-cols-2 gap-4">
                        {isActingAs ?
                        <PlanCard price={totalPrice} unitPrice={unitPrice} insuranceCompanies={companies} canPay={canPay} onMarkAsPaid={markAsPaid} isMarkingPaid={isMarkingPaid}></PlanCard>
                        :
                        <PlanCard price={totalPrice} unitPrice={unitPrice} insuranceCompanies={companies} canPay={canPay} widgetReady={widgetReady}></PlanCard>
                        }
                    </div>
                </div>
                {!isActingAs && <PaymentPage paymentAmount={totalPrice} userEmail={userEmail} userId={userId} onWidgetReady={() => setWidgetReady(true)} />}
            </div>
            :
            <div className="loader-container">
                <div className="spinner"></div>
            </div>
        }   
    </div>
  );
}

